import React, { useEffect, useState } from "react";
import { api } from "../api";
import "../sass/components/modalDataTolerancia.scss";
import { showInfo, showError } from "../utils/toast";

const formatarDataInput = (data) => {
  const ano = data.getFullYear();
  const mes = String(data.getMonth() + 1).padStart(2, "0");
  const dia = String(data.getDate()).padStart(2, "0");

  return `${ano}-${mes}-${dia}`;
};

const obterLimitesTolerancia = () => {
  const hoje = new Date();

  const dataMaxima = new Date(
    hoje.getFullYear(),
    hoje.getMonth(),
    hoje.getDate() + 10,
  );

  return {
    minDateStr: formatarDataInput(hoje),
    maxDateStr: formatarDataInput(dataMaxima),
  };
};

const ModalDataTolerancia = ({
  isOpen,
  onClose,
  codigoCadastro,
}) => {
  const [novaData, setNovaData] = useState("");
  const [ultimaData, setUltimaData] = useState("00/00/0000");
  const [loading, setLoading] = useState(false);
  const [loadingUltimaData, setLoadingUltimaData] = useState(false);

  const { minDateStr, maxDateStr } = obterLimitesTolerancia();

  useEffect(() => {
    if (!isOpen) return undefined;

    setNovaData("");

    if (!codigoCadastro) {
      setUltimaData("00/00/0000");
      return undefined;
    }

    let ativo = true;

    const carregarUltimaData = async () => {
      setLoadingUltimaData(true);

      try {
        const response = await api.get(
          `/cliente/tole/${codigoCadastro}`,
        );

        const payload = response?.data;

        const registro = Array.isArray(payload)
          ? payload[0]
          : Array.isArray(payload?.data)
            ? payload.data[0]
            : payload?.data || payload;

        const data =
          registro?.DtTole ??
          registro?.dtTole ??
          null;

        if (ativo) {
          setUltimaData(data || "00/00/0000");
        }
      } catch (error) {
        console.error(
          "Erro ao buscar data de tolerância:",
          {
            status: error.response?.status,
            data: error.response?.data,
            message: error.message,
          },
        );

        if (ativo) {
          setUltimaData("00/00/0000");
        }
      } finally {
        if (ativo) {
          setLoadingUltimaData(false);
        }
      }
    };

    carregarUltimaData();

    return () => {
      ativo = false;
    };
  }, [isOpen, codigoCadastro]);

  const handleChangeData = (event) => {
    setNovaData(event.target.value);
  };

  const handleSalvar = async () => {
    if (loading) return;

    if (!codigoCadastro) {
      showError("Cliente não informado.");
      return;
    }

    if (!novaData) {
      showError("Informe a data de tolerância.");
      return;
    }

    // YYYY-MM-DD permite comparação lexical segura.
    if (novaData < minDateStr) {
      showError(
        "A data de tolerância não pode ser anterior à data atual.",
      );
      return;
    }

    if (novaData > maxDateStr) {
      showError(
        "A data de tolerância não pode ultrapassar 10 dias.",
      );
      return;
    }

    setLoading(true);

    try {
      await api.put(
        `/cliente/dttole/${codigoCadastro}`,
        {
          novaData,
        },
      );

      setUltimaData(
        novaData.split("-").reverse().join("/"),
      );

      showInfo(
        "Data de tolerância atualizada com sucesso.",
      );

      onClose();
    } catch (error) {
      const mensagem =
        error.response?.data?.message ||
        error.message ||
        "Erro ao atualizar data de tolerância.";

      console.error(
        "Erro ao atualizar tolerância:",
        {
          status: error.response?.status,
          data: error.response?.data,
          message: error.message,
        },
      );

      showError(mensagem);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div
      className="modal-overlay"
      role="presentation"
    >
      <div
        className="modal-data-tolerancia"
        role="dialog"
        aria-modal="true"
        aria-labelledby="titulo-data-tolerancia"
      >
        <button
          type="button"
          className="btn-fechar"
          onClick={onClose}
          disabled={loading}
          aria-label="Fechar"
        >
          ×
        </button>

        <h2 id="titulo-data-tolerancia">
          Data de Tolerância
        </h2>

        <div className="input-group">
          <input
            type="date"
            value={novaData}
            onChange={handleChangeData}
            max={maxDateStr}
            min={minDateStr}
            disabled={loading}
          />

          <button
            type="button"
            onClick={handleSalvar}
            disabled={
              loading ||
              !novaData ||
              !codigoCadastro
            }
          >
            {loading ? "Gravando..." : "Gravar"}
          </button>
        </div>

        <div className="ultima-data">
          <div>Última data de tolerância</div>

          <span>
            {loadingUltimaData
              ? "Carregando..."
              : ultimaData}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ModalDataTolerancia;